import {createAction, props} from '@ngrx/store';
import {RMedewerker} from '../../services/somtoday.service';
import {Payload} from '../payload';

export const setMe = createAction('[ME] Set me', props<Payload<RMedewerker>>());
